// extracted by mini-css-extract-plugin
export default {"fieldset":"QuizFieldset-module__fieldset__oCbni","legend":"QuizFieldset-module__legend__YrFHW"};